import { useEffect, useState } from 'react';

/** Somehow windows add decimal part and the height of the filter is 25.6 instead of 25 */
const oneLineTextHeight = 26;

export function useFilterSize(
  ref: React.MutableRefObject<HTMLSpanElement | null>
): void {
  const [dotted, setDotted] = useState(false);

  useEffect(() => {
    if (ref.current && !dotted) {
      const node: any = ref.current;

      if (node.clientHeight > oneLineTextHeight) {
        const width = node.clientWidth;
        node.style.textOverflow = 'ellipsis';
        node.style.overflow = 'hidden';
        node.style.whiteSpace = 'nowrap';
        node.style.width = `${width}px`;
      }
      setDotted(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current, dotted]);

  useEffect(() => {
    window.addEventListener('resize', onResize);

    function onResize(): void {
      const node: any = ref.current;
      if (node) {
        node.style.whiteSpace = '';
        node.style.width = '';
      }
      setDotted(false);
    }

    return function unmount(): void {
      window.removeEventListener('resize', onResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
